// extracted by mini-css-extract-plugin
export default {"main":"u8M13aUO--styles_main__N3orD","wrapper":"u8M13aUO--styles_wrapper__DZFxN","mainBody":"u8M13aUO--styles_mainBody__p1c+5","shimmer":"u8M13aUO--styles_shimmer__q68z7"};